import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ProceduresDTO } from '../company-user/userProfileDTO.model';
import { ContactsDTO, MyContactsDTO, ShareProcedureToContactsDTO } from '../Models/Contact.model';
import { CustomCategoryDTO, EquipmentDTO } from '../Models/Equipment.model';
import { ProcedureDTO, UserProcedureDataDTO, SpecialityImageDTO } from '../Models/Procedure.model';
import { SpecialityDTO } from '../Models/Speciality.model';
import { Globals } from '../Models/UserProfile.model';
import { ProcedureComponent } from '../procedure/procedure.component';
import { AppWideUser, Token } from '../Services/AppUserProfile';
import { SrubUpService } from '../Services/ScrubUp.service';
import { UserService } from '../Services/user.service';
import { environment } from '../../environments/environment';
import { DIR_DOCUMENT } from '@angular/cdk/bidi';
declare var swal: any;

@Component({
  selector: 'app-user-procedure',
  templateUrl: './user-procedure.component.html',
  styleUrls: ['./user-procedure.component.scss'],
  providers: [SrubUpService, UserService, ProcedureComponent]
})
export class UserProcedureComponent implements OnInit {
  uploadUrl: string;
  custEquipmentlist: any = [];
  customEquipmentCat: any = [];
  public baseurl: string = environment.base_url;
  catgIndex: number;
  equipmntIndex: number;
  editModeOn: boolean;
  showAssignEquipment: boolean;
  customEquipmentCategories: Array<CustomCategoryDTO>;

  equipmentName: string;
  specification: string;
  quantity: number;
  imagePath: string;
  categoryName: string;
  EquipmentId: string;

  fullEquipmentsList: Array<EquipmentDTO>;
  equipmentcategories: Array<string>;
  categoryequipments: Array<EquipmentDTO>;

  invisible: number;
  sharedUserInfo: MyContactsDTO;
  procedureToShare: ProcedureDTO;
  contacts: ContactsDTO;
  myContactsList: Array<MyContactsDTO>;
  shareProcedureToContactsList: Array<ShareProcedureToContactsDTO>;
  shareProcedureToContact: ShareProcedureToContactsDTO;
  shareProcedureToUserIds: Array<number>;
  loginUserId: number;
  detailViewIcon: number;

  selectedProcSpeciality: string;
  selectedProcedureName: string;
  userProcedureData: UserProcedureDataDTO;
  procedureName: string;
  description: string;
  specialityId: number;
  procedures: Array<ProcedureDTO>;
  specialities: Array<SpecialityDTO>;

  codeValue: string;
  descriptionValue: string;
  iValue: number;
  showEquipmentEditingDiv: boolean;
  step: string;
  universalHideAndShowMpId;
  isMobile;
  deviceOfflineColm: boolean;
  index: boolean;
  edit: boolean;
  equipmnt: boolean;

  userId: number;

  selectedRoles: Array<string>;
  public loading = false;
  showAlreadyExist: boolean;

  procedure: ProceduresDTO;

  httpClient: any;
  addImageInvisible: number;
  addChecklistItem: number;
  selectedProcedureId: any;
  category: number;
  createProcedure: number;
  isImpersonateMode: boolean;
  getAdminValues: boolean;

  specialityName: string;
  selectedSpecialityId: number;

  imageUploadApiUrlLength: number;
  myHeaders: { [name: string]: any };
  tempUrl: Array<string>;

  specialityImagesList: Array<SpecialityImageDTO>;

  imageToShow: string;
  specialityIdArray: any = {};
  procedureArray: any = {};
  constructor(private router: Router, private userService: UserService, private cookieService: CookieService, private appUser: AppWideUser, private token: Token, private scrubUpService: SrubUpService) {
    if (this.appUser.UserName == undefined && this.token.access_token == undefined || this.appUser.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUser = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
      Globals.SpecialityName = this.cookieService.get('specialityName');
      Globals.SpecialityId = parseInt(this.cookieService.get('specialityId'));
    }

    this.specialityImagesList = new Array<SpecialityImageDTO>();

    this.editModeOn = false;
    this.showAssignEquipment = false;
    this.userProcedureData = new UserProcedureDataDTO;
    this.invisible = 0;
    this.getAdminValues = false;

    this.isImpersonateMode = JSON.parse(this.cookieService.get('impersonation'));
    if (this.isImpersonateMode == true) {
      this.loginUserId = JSON.parse(this.cookieService.get('userId'));
    }
    else {
      this.loginUserId = this.appUser.UserId;
    }

    this.procedures = new Array<ProcedureDTO>();
    this.specialities = new Array<SpecialityDTO>();

    this.customEquipmentCategories = new Array<CustomCategoryDTO>();

    this.detailViewIcon = -1;

    this.iValue = -1;
    this.showEquipmentEditingDiv = false;
    this.addImageInvisible = 0;
    this.addChecklistItem = 0;

    this.universalHideAndShowMpId = 0;
    this.deviceOfflineColm = true;

    this.specialityName = Globals.SpecialityName;
    this.selectedSpecialityId = Globals.SpecialityId;
    this.index = true;

    this.uploadUrl = this.baseurl + "api/Speciality/UploadImage?userId=" + this.loginUserId;

    this.imageUploadApiUrlLength = (this.baseurl + "api/Speciality/GetUploadedImage?imageName=").length;
    this.myHeaders = {
      'Authorization': 'Bearer ' + this.token.access_token,
      'UserId': this.appUser.UserId,
      'ModulePath': "Equipments"
    };
    this.tempUrl = new Array<string>();
  }

  ShowImage(i, j) {
    this.imageToShow = this.customEquipmentCategories[i].Equipments[j].ImageBase64;
  }

  OnUploadFinished(response: any) {
    if (response.serverResponse.response.status == "200") {
      this.imagePath = response.serverResponse.response._body;
      this.imagePath = this.imagePath.substring(1, this.imagePath.length - 1);
    }
  }

  GetImage(imageSrc) {
    imageSrc.forEach(element => {
      this.scrubUpService.GetImage(this.token, element, this.appUser.UserId).subscribe(ab => {
        this.fullEquipmentsList.forEach(a => {
          if (a.ImagePath == element) {
            a.ImageBase64 = "data:image/png;base64," + ab
          }
        });
      });

    });
  }

  ShareIt(index) {
    this.procedureToShare = new ProcedureDTO;
    this.procedureToShare = this.procedures[index];
    this.selectedProcedureId = this.procedureToShare.ID;
    this.specialityId = this.procedureToShare.SpecialityID;
  }

  ShareProcedure() {
    this.shareProcedureToUserIds = new Array<number>();
    this.shareProcedureToContactsList.forEach(element => {
      if (element.IsChecked && element.IsGroup != "true") {
        this.shareProcedureToUserIds.push(element.UserId);
      }
      else if (element.IsChecked && element.IsGroup == "true") {
        element.ContactsGroup.GroupMembers.forEach(ele => {
          this.shareProcedureToUserIds.push(ele.UserId);
        });
      }
    });
    this.shareProcedureToUserIds = this.shareProcedureToUserIds.filter(this.onlyUnique);   // suppose procedure shared with 'one group' and 'one individual contact'. Here, if group also includes that contact then to handle(filter) duplicate.
    if (this.shareProcedureToUserIds.length > 0) {
      this.loading = true;
      let SharedAtDateTime: string;
      SharedAtDateTime = new Date().toString();
      this.scrubUpService.ShareProcedure(this.token, this.shareProcedureToUserIds, this.specialityId, this.selectedProcedureId, this.loginUserId, SharedAtDateTime).subscribe(x => {
        if (x == "success") {
          swal({
            title: 'Shared with selected contacts.',
            type: "success",
            timer: 2000,
            showConfirmButton: false
          }).catch(swal.noop);
        }
        else {

        }
        this.loading = false;
      });
    }
    else { return; }
  }

  SetProcedureId(specialityId: number, pId: string, categoryId: number, SpecialityName: any, procedureName: any) {

    Globals.PId = pId;
    Globals.SpecialityId = specialityId;
    Globals.CategoryId = categoryId;
    Globals.LoginUsrId = this.loginUserId;
    // Globals.SpecialityName = specialityName;
    //var x = this.findObjectByKey(this.procedures, 'ID', pId);
    // this.selectedProcedureName = x.Name;
    this.cookieService.set("specialityId", Globals.SpecialityId.toString());
    this.cookieService.set("procedureName", procedureName);
    this.selectedProcedureName = procedureName;
  }

  getEquipChecklistDetails(specialityId: number, pId: string, categoryId: number, procedureName: any) {
    //  alert(2);
    this.customEquipmentCat=[];
    this.selectedProcedureId = pId;
    Globals.PId = pId;
    this.specialityId = specialityId;
    Globals.SpecialityId = specialityId;
    Globals.CategoryId = categoryId;
    // alert(procedureName);
    this.selectedProcedureName = procedureName;

    this.scrubUpService.UserEquipmentsListByUserProcedureID(this.token, Globals.PId).subscribe(x => {
      // console.log(x);
      if (x['Data'] != null && x.Status == true) {
        this.custEquipmentlist = x['Data'];
        //console.log(this.custEquipmentlist);


        this.scrubUpService.GetEquipmentCategoryList(this.token, this.loginUserId).subscribe(x => {
          //console.log(x);
          if (x['Data'] != null && x.Status == true) {
            this.customEquipmentCat = x['Data'];

            //console.log(this.customEquipmentCat);
            for (var j = 0; j < this.customEquipmentCat.length; j++) {
              let doesexist = false;
              for (var i = 0; i < this.custEquipmentlist.length; i++) {
                  //console.log(this.customEquipmentCat[j]['ECID']);
                // console.log(this.custEquipmentlist[i]['ECID']);
                if (this.customEquipmentCat[j]['ECID'] == this.custEquipmentlist[i]['ECID']) {
                  doesexist = true;
                }
                if (doesexist) {
                  this.customEquipmentCat[i]['UserEquipmentList'] = this.custEquipmentlist[i]['UserEquipmentList'];
                }
              }

            }

          }
          this.loading = false;
        },
          error => {
            this.loading = false;
          })



      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })




  }

  //category list
  getEquipmentCategoryList() {
    this.loading = true;
    this.scrubUpService.GetEquipmentCategoryList(this.token, this.loginUserId).subscribe(x => {
      //console.log(x);
      if (x['Data'] != null && x.Status == true) {
        this.customEquipmentCat = x['Data'];
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  //equipment list
  getEquipmentList() {

    this.customEquipmentCategories = [];
    let custEquipment: CustomCategoryDTO;
    let tempEquipments: Array<EquipmentDTO>;
    tempEquipments = new Array<EquipmentDTO>();


    this.scrubUpService.UserEquipmentsListByUserProcedureID(this.token, Globals.PId).subscribe(x => {

      if (x['Data'] != null && x.Status == true) {
        this.custEquipmentlist = x['Data'];
        this.scrubUpService.GetEquipmentCategoryList(this.token, this.loginUserId).subscribe(x => {
          if (x['Data'] != null && x.Status == true) {
            this.customEquipmentCat = x['Data'];
            for (var j = 0; j < this.customEquipmentCat.length; j++) {
              let doesexist = false;
              for (var i = 0; i < this.custEquipmentlist.length; i++) {
                if (this.customEquipmentCat[j]['ECID'] == this.custEquipmentlist[i]['ECID']) {
                  doesexist = true;
                }
                if (doesexist) {
                  this.customEquipmentCat[i]['UserEquipmentList'] = this.custEquipmentlist[i]['UserEquipmentList'];
                }
              }
            }
          }
          this.loading = false;
        },
          error => {
            this.loading = false;
          })

      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  findObjectByKey(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
    return null;
  }

  cancelAddProc() {
    this.createProcedure = 0;
  }

  OnDoctorsTabClick() {
    this.cookieService.set("doctorFlag", "true");
    this.router.navigate(["layout/surgeonlist"]);
  }

  UserClick(btnCount) {
    this.index = false;
    this.edit = false;
    if (btnCount == 0) {
      this.createProcedure = 1;
      this.index = true;
      this.edit = false;
    }
    if (btnCount == 1) {
      this.index = true;
      this.edit = false;
      this.selectedProcedureId = 0;
      this.category = 0;
    }
    if (btnCount == 5) {//eq
      this.equipmnt = false;

      this.showEquipmentEditingDiv = false;
      this.equipmentName = "";
      this.specification = "";
      this.quantity = 0;
      this.categoryName = "";
      this.imagePath = "";
      this.EquipmentId = "";
    }
    if (btnCount == 6) {//eq
      this.equipmnt = false;

      this.showEquipmentEditingDiv = false;
      this.invisible = 0;
      this.equipmentName = "";
      this.specification = "";
      this.quantity = 0;
      this.categoryName = "";
    }
    if (btnCount == 2) {
      this.index = false;
      this.edit = true;
    }
    if (btnCount == 3) {
      this.edit = true;
      this.addImageInvisible = 1;
    }
    if (btnCount == 4) {
      this.showAssignEquipment = true;
      this.index = false;
      this.edit = false;
    }
  }

  ngOnInit() {

    this.GetSpecialities();
    this.GetOnlySpecialityProcedures();
   this.GetContactsInfo();
    this.getEquipmentCategoryList();
  }

  GetOnlySpecialityProcedures() {
        // Check if userSpecialityId exists in cookie
    if (!this.cookieService.check("userSpecialityId") ||
        ["null", null, "undefined"].includes(this.cookieService.get("userSpecialityId"))) {
      // Navigate to user-speciality route if userSpecialityId is null or undefined
      this.router.navigate(["layout/user-speciality"]);
      return;
    }

    let userSpecialityId = JSON.parse(this.cookieService.get("userSpecialityId"));

     this.procedures = [];
     this.loading = true;

    let packageTypesFeatures = JSON.parse(
      this.cookieService.get("PackageTypesFeatures")
    );

    const isPackageDowngraded = packageTypesFeatures.IsPackageDowngraded
      ? packageTypesFeatures.IsPackageDowngraded
      : false;

    const procedure = JSON.parse(localStorage.getItem("Procedure"));

    const featureValue = (procedure && procedure.FeatureValue) ? procedure.FeatureValue : 0;

    this.specialityIdArray = {
      UserSpecialityID: userSpecialityId,
      FeatureValue: featureValue,
      IsPackageDowngraded: isPackageDowngraded
    };

    this.scrubUpService.GetSpecialityProcedures(this.token, this.specialityIdArray).subscribe(x => {
      if (x.Status == true) {
        this.procedures = x.Data;
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  navToParent() {
    if (this.index == false) {
      this.router.navigateByUrl('layout', { skipLocationChange: true }).then(() =>
        this.router.navigate(["layout/user-procedure"]));
    }
    else
      this.router.navigateByUrl("/layout/user-speciality");
  }

  GetContactsInfo() {
    this.shareProcedureToContactsList = new Array<ShareProcedureToContactsDTO>();
    this.loading = true;
    this.scrubUpService.GetContactsInfo(this.token, this.loginUserId).subscribe(x => {
      if (x != null && x != undefined) {
        this.contacts = x;
        if (x.MyContacts != null && x.MyContacts != undefined) {
          this.myContactsList = this.contacts.MyContacts;
          this.myContactsList.forEach(element => {
            this.shareProcedureToContact = new ShareProcedureToContactsDTO;
            this.shareProcedureToContact.UserId = element.UserId;
            this.shareProcedureToContact.Name = element.Name;
            this.shareProcedureToContact.MobileNumber = element.MobileNumber;
            this.shareProcedureToContact.Email = element.Email;
            this.shareProcedureToContact.IsChecked = false;
            this.shareProcedureToContact.ContactsGroup = element.ContactsGroup;
            this.shareProcedureToContact.IsGroup = element.IsGroup;
            this.shareProcedureToContactsList.push(this.shareProcedureToContact);
          });
        }
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  GetSpecialities() {
    this.loading = true;
    this.getAdminValues = true;
    this.scrubUpService.GetSpecialities(this.token, 1, this.getAdminValues).subscribe(x => {
      if (x['Data'] != null && x != undefined) {
        this.specialities = x['Data'];

      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
    this.getAdminValues = false;
  }

  GetSpecialityImage(imageSrc: Array<SpecialityImageDTO>) {
    imageSrc.forEach(element => {
      this.scrubUpService.GetImage(this.token, element.ImagePath, 1).subscribe(ab => {
        element.ImageBase64 = "data:image/png;base64," + ab
      });
    });
  }

  GetImageBase64(specialityId: number) {
    var speciality = this.specialityImagesList.find(x => x.SpecialityId == specialityId);
    if (speciality != undefined && speciality != null) {
      var imageBase64 = speciality.ImageBase64
      if (imageBase64 != undefined && imageBase64 != null && imageBase64 != "") {
        return imageBase64;
      }
      else {
        return "";
      }
    }
    else {
      return "";
    }
  }

  ShowSharedByInfo(sharedByUserId, dateTime) {
    let sharedAtDtTime: string;
    sharedAtDtTime = new Date(dateTime).toLocaleString();
    this.sharedUserInfo = new MyContactsDTO();
    this.sharedUserInfo = this.findObjectByKey(this.myContactsList, 'UserId', sharedByUserId);
    if (this.sharedUserInfo != null) {
      swal(
        {
          text: "Procedure shared by ...",
          html: '<div class="well"><label style="font-size:18px;">Shared user info...</label><hr><strong style="font-size:18px;">User Name : </strong>' + this.sharedUserInfo.Name + '<br><br>' +
            '<strong style="font-size:18px;">Email_Id : </strong>' + this.sharedUserInfo.Email + '<br><br>' +
            '<strong style="font-size:18px;">Mobile Number : </strong>' + this.sharedUserInfo.MobileNumber + '<br><br><label style="font-size:12px;text-align:left;">' + sharedAtDtTime + '</label></div>'
        }
      ).catch(swal.noop);
    }
    else {
      swal(
        {
          text: "missing contact info"
        }
      ).catch(swal.noop);
    }
  }

  AddProcedure() {
    let procedure: ProcedureDTO;
    procedure = new ProcedureDTO();
    this.procedureArray.UserSpecilalityID = this.specialityId;
    this.procedureArray.UserProcedureID = 0;
    this.procedureArray.Name = this.procedureName;
    this.procedureArray.Description = this.description;
    this.loading = true;
    this.scrubUpService.AddProcedure(this.token, this.procedureArray).subscribe(x => {

      if (x.Status == true) {
        swal({
          title: 'Procedure Created Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        this.cancelAddProc();
        this.GetOnlySpecialityProcedures();
      }
      else if (x.Status == false) {
        swal({
          title: 'Procedure Already Exists',
          type: "info",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
      }
      else {

      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      });
  }

  DeleteProcedure(index: any) {
    this.loading = true;
    let deleteSpecArray = {
      // "UserProcedureID":UserProcedureID,
      // "UserSpecilalityID":UserSpecialityID
    };
    this.scrubUpService.DeleteProcedures(this.token, deleteSpecArray).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'Procedure Deleted Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        this.cancelAddProc();
        this.GetOnlySpecialityProcedures();
      }
      else if (x == "Failure") {
        swal({
          title: 'Deletion Failed!!',
          type: "info",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
      }
      else {

      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      });
  }

  addEquipmentbtn() {
    this.equipmnt = true;
  }

  equipEditModeOn() {
    this.editModeOn = this.editModeOn == true ? false : true;
    this.showEquipmentEditingDiv = false;
    this.equipmnt = false;
  }

  editEquipment(catgIndx, equipIndx) {
    this.catgIndex = catgIndx;
    this.equipmntIndex = equipIndx;
    let toEditEquipment: EquipmentDTO;
    toEditEquipment = new EquipmentDTO();
    toEditEquipment = this.customEquipmentCategories[catgIndx].Equipments[equipIndx];
    this.categoryName = toEditEquipment.CategoryName;
    this.equipmentName = toEditEquipment.Name;
    this.specification = toEditEquipment.Specification;
    this.quantity = toEditEquipment.Quantity;
    this.EquipmentId = toEditEquipment.ID;
    this.imagePath = toEditEquipment.ImagePath;
    this.showEquipmentEditingDiv = true;
    this.equipmnt = true;
  }

  AddUserEquipment() {
    let equipment: EquipmentDTO;
    equipment = new EquipmentDTO();
    equipment.Name = this.equipmentName;
    equipment.CategoryName = this.categoryName;
    equipment.ImagePath = this.imagePath;
    equipment.Specification = this.specification;
    equipment.Quantity = this.quantity;
    equipment.ID = "";
    this.loading = true;
    //, Globals.SpecialityId, Globals.PId, this.appUser.UserId
    this.scrubUpService.AddUserEquipment(this.token, equipment).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'Equipment Added Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        this.UserClick(5);
        //this.getEquipChecklistDetails(Globals.SpecialityId, Globals.PId, Globals.CategoryId);
        this.equipmentName = "";
        this.specification = "";
        this.quantity = null;
      }
      else {

      }
      this.loading = false;
    });
  }

  UpdateUserEquipment() {
    this.equipmnt = true;
    let equipment: EquipmentDTO;
    equipment = new EquipmentDTO();
    equipment.ID = this.EquipmentId;
    equipment.Specification = this.specification;
    equipment.Quantity = this.quantity;
    equipment.ImagePath = this.imagePath;
    equipment.Name = this.equipmentName;
    equipment.CategoryName = this.categoryName;

    this.loading = true;
    this.scrubUpService.UpdateUserEquipment(this.token, equipment, Globals.SpecialityId, Globals.PId, this.appUser.UserId).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'Update Successful',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        this.UserClick(5);
        this.GetOnlySpecialityProcedures();
        // this.getEquipChecklistDetails(Globals.SpecialityId, Globals.PId, Globals.CategoryId);
      }
      else {

      }
      this.loading = false;
    });
  }
}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/user-procedure/user-procedure.component.ts